import React from "react";
import "./Footer.scss";
import styles from "../../login/login.module.scss";

const DisclaimerComponent: React.FC = () => {
  return (
    // mb stays 0 (bottom spacing via padding) so the gradient wrapper reaches
    // the document bottom — a bottom margin here leaks past .bg-gradient-main
    // and exposes the flat body background as a navy bar under the footer.
    <footer className="footer-container p-2 mx-4 mt-4 mb-0 pb-4 light-top-brder">
      <div className="left-content">
        <div className={styles.shine + " copy-header"}>
          © Copyright BookieBrawler 2026
        </div>

        <p className="py-3 pb-5">
          Need help or have questions? Our team is here to assist you! Feel free
          to reach out to us anytime at{" "}
          <a
            href="mailto:notifications@bookiebrawler.com"
            style={{ textDecoration: "underline", color: "#97c5df" }}
          >
            notifications@bookiebrawler.com
          </a>{" "}
          for any inquiries or support. We’re happy to help!
        </p>

        {/* Accurate, and consistent with the Terms: BookieBrawler publishes
            odds analysis and never takes a wager. The old copy claimed the
            site "does not involve real money betting", which read as a
            promise we can't make about what members do with the numbers. */}
        <p className="py-3 pb-5">
          BookieBrawler is an odds and analytics service for adults 21 and over.
          We are not a sportsbook: we do not accept wagers or hold funds, and
          nothing here is betting advice or a guarantee of profit. Bet only what
          you can afford to lose, and check the price at your sportsbook before
          you place anything. If you or someone you know has a gambling problem,
          call 1-800-GAMBLER. Help is free and confidential.
        </p>
      </div>
    </footer>
  );
};

export default DisclaimerComponent;
